export enum CenterAlignedContentWidth {
  ExtraLarge = 1320,
  Large = 960,
  Medium = 720,
  Adaptive = '100%',
}

export enum CenterAlignedContentMargin {
  ExtraLarge = 0,
  Large = 44,
  Medium = 32,
  Small = 24,
}

export enum Spacing {
  Size_1 = 2,
  Size_2 = 4,
  Size_3 = 6,
  Size_4 = 8,
  Size_5 = 10,
  Size_6 = 12,
  Size_7 = 14,
  Size_8 = 16,
  Size_9 = 18,
  Size_10 = 20,
  Size_11 = 22,
  Size_12 = 24,
  Size_13 = 26,
  Size_14 = 28,
  Size_15 = 30,
  Size_16 = 32,
  Size_17 = 34,
  Size_18 = 36,
  Size_19 = 38,
  Size_20 = 40,
  Size_21 = 42,
  Size_22 = 44,
  Size_23 = 46,
  Size_24 = 48,
  Size_25 = 50,
  Size_26 = 52,
  Size_27 = 54,
  Size_28 = 56,
  Size_29 = 58,
  Size_30 = 60,
  Size_31 = 62,
  Size_32 = 64,
}

export enum BorderRadiuse {
  Size_1 = 2,
  Size_2 = 4,
  Size_3 = 6,
  Size_4 = 8,
  Size_5 = 10,
  Size_6 = 12,
  Size_7 = 14,
  Size_8 = 16,
  Size_9 = 18,
  Size_10 = 20,
  Size_11 = 22,
  Size_12 = 24,
  Size_13 = 26,
  Size_14 = 28,
  Size_15 = 30,
  Size_16 = 32,
  Size_17 = 34,
  Size_18 = 36,
  Size_19 = 38,
  Size_20 = 40,
  Size_21 = 42,
  Size_22 = 44,
  Size_23 = 46,
  Size_24 = 48,
  Size_25 = 50,
  Size_26 = 52,
  Size_27 = 54,
  Size_28 = 56,
  Size_29 = 58,
  Size_30 = 60,
  Size_31 = 62,
  Size_32 = 64,
}

export enum Transition {
  Fast = '0.1s',
  Default = '0.3s',
  DropDown = '0.46s',
  Long = '1s',
}

export const Breakpoint = {
  ExtraLarge: 1365,
  Large: 1023,
  Medium: 767,
  Small: 766,
};

export enum AspectRatioDimension {
  Full = '100%', // 100:100
  HD = '56.25%', // 16:9
  Standard = '75%', // 4:3
  Classic = '66.6%', // 3:2
  CinemaScope = '42.8%', // 21:9
}
